import React from 'react';
import classnames from 'classnames';
import { AdType } from '@gik/ads/components/Ad';

const blockName = 'ad-container';
export const adBlockElName = `${blockName}__ad`;

export default function AdContainer({
  children,
  className = '',
  adType,
}: React.PropsWithChildren<{
  className?: string;
  adType: AdType;
}>) {
  const blockClassNames: string = classnames([blockName, `${blockName}--${adType}`, className]);

  return (
    <div className={blockClassNames}>
      <p>ADVERTISEMENT</p>
      {children}
    </div>
  );
}
